import { Dispatch, SetStateAction } from "react";
import { useTenant } from "../../Contexts/TenantContext";
import { PaymentMethod } from "../../Enums/PaymentMethod";
import { CreditCardData } from "../../Types/CreditCardDataType";
import { FaEye } from "react-icons/fa";
import PaymentOptionCard from "../PaymentOptionCard/PaymentOptionCard";

type PaymentStepProps = {
  selectedPaymentMethod: PaymentMethod | null;
  onSelectPaymentMethod: (method: PaymentMethod) => void;
  creditCardData: CreditCardData;
  onCreditCardDataChange: Dispatch<SetStateAction<CreditCardData>>;
  orderPrice: number;
};

const PaymentStep = ({
  selectedPaymentMethod,
  onSelectPaymentMethod,
  creditCardData,
  onCreditCardDataChange,
  orderPrice
}: PaymentStepProps) => {
  const { tenantPreference } = useTenant();
  return (
    <div className={`flex flex-col bg-white border p-4 gap-5 flex-[1.6] rounded shadow`}>
      <div className="flex items-center gap-2">
        <FaEye className="text-primary-600" />
        <h3 className="font-bold">{"FORMA DE PAGAMENTO"}</h3>
      </div>

      <div className="space-y-4">
        {tenantPreference.enablePix && (
          <PaymentOptionCard
            key="pix"
            id="pix"
            label="PIX"
            description={"Pagamento instantâneo via PIX, com confirmação rápida e processamento imediato após a finalização da compra."}
            selected={selectedPaymentMethod === PaymentMethod.Pix}
            onSelect={() => onSelectPaymentMethod(PaymentMethod.Pix)}
            isEnabled
          />
        )}

        {tenantPreference.enableBankingBillet && (
          <PaymentOptionCard
            key="banking-billet"
            id="banking-billet"
            label={"Boleto Bancário"}
            description={"O boleto será gerado após a finalização do pedido. Caso não seja pago até o vencimento, o pedido será cancelado automaticamente."}
            selected={selectedPaymentMethod === PaymentMethod.BankingBillet}
            onSelect={() => onSelectPaymentMethod(PaymentMethod.BankingBillet)}
            isEnabled
          />
        )}

        {tenantPreference.enableCreditCard && (
          <PaymentOptionCard
            key="credit-card"
            id="credit-card"
            label={"Cartão de Crédito"}
            description={"Insira os dados do cartão para parcelar sua compra."}
            selected={selectedPaymentMethod === PaymentMethod.CreditCard}
            onSelect={() => onSelectPaymentMethod(PaymentMethod.CreditCard)}
            isEnabled
            creditCardData={creditCardData}
            onCreditCardDataChange={onCreditCardDataChange}
            orderPrice={orderPrice}
          />
        )}
      </div>
    </div>
  );
};

export default PaymentStep;
